<template>
  <div
    class="bg-static-brand-mid rounded-lg box-border p-4 sm:border-0 md:border-0"
  >
    <div
      class="text-static-brand-mid body-2-bold flex flex-row items-center gap-12 px-16 py-14 md:px-22"
    >
      <IconSwap />
      <span>{{ i18n(translations.swapIntroduction) }}</span>
    </div>
    <div
      class="bg-float-default-low border-static-default-low rounded-md box-border flex flex-col items-stretch justify-between border p-16 sm:border-0 md:border-0 md:p-24"
    >
      <span class="body-1-bold mb-12 md:mb-8">
        {{ i18n(translations.swapTitle) }}
      </span>

      <div class="flex flex-col justify-between gap-16 md:flex-row md:gap-96">
        <div>
          <span class="body-2">
            {{ i18n(translations.swapSubtitle) }}
          </span>
          <p>
            <RevLink class="body-2" @click="handleHowItWorks">{{
              i18n(translations.howItWorks)
            }}</RevLink>
          </p>
        </div>
        <div>
          <RevButton
            full-width="always"
            variant="secondary"
            @click.stop="emit('see-swap')"
          >
            <span>
              {{ i18n(translations.getSwapEstimation) }}
            </span>
          </RevButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { inject, ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButton } from '@ds/components/Button'
import { RevLink } from '@ds/components/Link'
import { IconSwap } from '@ds/icons/IconSwap'

import type { ErrorData } from '~/scopes/buyback/components/TheCatcher/useCatcher'

import { SWAP_INFO_MESSAGE } from '../EmbeddedSwapModal/constants'

import translations from './SwapBlockCart.translations'

const { trackClick } = useTracking()
const i18n = useI18n()

const emit = defineEmits(['see-swap', 'see-more'])

const errorData = inject<ErrorData>('errorData', ref({ message: '', step: '' }))
errorData.value = { message: SWAP_INFO_MESSAGE.SWAP_BLOCK, step: '' }

function handleHowItWorks() {
  trackClick({
    name: 'tradein_info',
    zone: 'swap_cart',
  })

  emit('see-more')
}
</script>
